
define('template!ordersDetailPriceV2PrintPriceView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<td class="pricev2-print-select">\n  <input class="checkbox-enable-disable-pz" type="checkbox" ' +
((__t = ( checked?'checked':'')) == null ? '' : __t) +
' />\n  <i class="mdi-action-check-circle icon btn-save-change-enable-pz clickable" style="display: none;"></i>\n</td>\n<td>' +
((__t = ( index )) == null ? '' : __t) +
'</td>\n';
 if (advancedMode) { ;
__p += '\n<td class="pricev2-print-preview">\n  ';
 if (pz.printPictures && pz.printPictures.length > 0) { ;
__p += '\n    <img class="pricev2-print-preview-img" src="' +
((__t = ( pz.printPictures[0].imageUrl )) == null ? '' : __t) +
'" data-link="' +
((__t = ( pz.printPictures[0].imageUrl )) == null ? '' : __t) +
'"/>\n  ';
 } ;
__p += '\n</td>\n';
 } ;
__p += '\n<td colspan="2">' +
((__t = ( pa.name )) == null ? '' : __t) +
'</td>\n<td colspan="2">' +
((__t = ( pz.name )) == null ? '' : __t) +
'</td>\n<td colspan="2">' +
((__t = ( pz.width + 'x' + pz.height + 'mm' )) == null ? '' : __t) +
'</td>\n';
 if (checked && pz.colorModeType === 'spot') { ;
__p += '\n<td class="pricev2-print-colors">\n  <select class="select-nbr-colors form-control input-sm">\n  ';
 for(var i = 1 ; i <= pz.maxColors ; i++) { ;
__p += '\n    <option ';
  if (composition.nbrColors === i) { ;
__p += ' selected ';
 } ;
__p += '>' +
((__t = ( i )) == null ? '' : __t) +
'</option>\n  ';
 } ;
__p += '\n  </select>\n  <i class="mdi-action-check-circle icon btn-save-change-nbr-colors clickable" style="display: none;"></i>\n</td>\n';
 } else { ;
__p += '\n<td>' +
((__t = ( pz.maxColors )) == null ? '' : __t) +
'</td>\n';
 } ;
__p += '\n<td>' +
((__t = ( setup )) == null ? '' : __t) +
'</td>\n<td>' +
((__t = ( handlingPrice )) == null ? '' : __t) +
'</td>\n';
 _.each(scales, function(scale) { ;
__p += '\n<td>' +
((__t = ( scale.unit )) == null ? '' : __t) +
'</td>\n';
 }); ;
__p += '\n';

}
return __p
};});

